import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Label, Input, FormGroup, Container } from 'reactstrap';
import ProjectSelector from '../components/Common/ProjectSelector';
import toastAlert from '../js/Base/ToastAlert';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useSelector, useDispatch } from "react-redux";
import { fetchBusinessMembers } from '../store/slices/businessSlice';
import { managerRoutes } from '../routes';

const itemTitle = {
  fontSize: '16px',
  fontWeight: "bold",
  textAlign: 'left',
  fontFamily: 'Noto Sans, sans-serif',
};

const styles = `
  .btn-link:hover {
    background-color: #f5f5f5;
  }
`;

export default function AdminManagement() {
  const dispatch = useDispatch();
  const [projectNo, setProjectNo] = useState(
    localStorage.getItem("project_uuid")
      ? localStorage.getItem("project_uuid")
      : ""
  );
  const [projects, setProjects] = useState([]);

  const ProjectRefresh = (newProjectNo) => {
    if (newProjectNo !== projectNo) {
      localStorage.setItem("project_uuid", newProjectNo);
      setProjectNo(newProjectNo);
      dispatch(fetchBusinessMembers());
    }
  };

  const isAdmin = useSelector(state => state.user.isAdmin);
  const isEdcAdmin = useSelector(state => state.businessMembers.isEdcAdmin);
  

  const role = isAdmin
  ? "admin"
  : isEdcAdmin
    ? "edcAdmin"
    : "manager";

  const allManagerRoutes = [...managerRoutes];

  // filter role
  const visibleRoutes = filterByRole(allManagerRoutes, role);
  const grouped = groupRoutes(visibleRoutes);

  const companyRoutes = grouped["company"] || [];
  const memberRoutes = grouped["project"] || [];
  const adminRoutesList = grouped["admin"] || [];

  return (
    <React.Fragment>
      <Container className="mt-2">
        <div className="CompanyManagement" style={{ marginRight: '20px' }}>
          <style>{styles}</style>
          <Row>
            <Col xs="6">
              <Label style={{ justifyContent: 'center', alignContent: 'center' }}>
                <p style={{ fontSize: '20px', fontWeight: "bold", color: '#1D1D1D', fontFamily: 'Noto Sans, sans-serif' }}>管理員設定</p>
              </Label>
            </Col>
            <Col xs="3" />
            <Col xs="3" style={{ justifyContent: 'right', alignContent: 'right' }}>
              <FormGroup>
                <Fragment>
                  <Label style={{ fontSize: '12px', color: '#1D1D1D' }}>
                    <strong>選擇專案</strong>
                  </Label>
                  <ProjectSelector projectSelect={ProjectRefresh} style={{ fontSize: '12px', color: '#1d1d1d' }} />
                </Fragment>
              </FormGroup>
            </Col>
          </Row>

          <div style={{ marginTop: '20px', marginBottom: '10px' }}>
            <span style={itemTitle}>公司管理</span>
          </div>
          <Row className="g-3">
            {companyRoutes.map(r => (
              <Col xs={6} key={r.path}>
                <Card className="card">
                  <Link className="btn-link" to={r.path}>{r.label}
                    <NavigateNextIcon className="next-icon" />
                  </Link>
                </Card>
              </Col>
            ))}
          </Row>

          {memberRoutes.length > 0 && (
            <>
              <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                <span style={itemTitle}>人員管理</span>
              </div>
              <Row className="g-3">
                {memberRoutes.map(r => (
                  <Col xs={6} key={r.path}>
                    <Card className="card">
                      <Link className="btn-link" to={r.path}>{r.label}
                        <NavigateNextIcon className="next-icon" />
                      </Link>
                    </Card>
                  </Col>
                ))}
              </Row>
            </>
          )}

          {(isAdmin || isEdcAdmin) && (
            <>
              <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                <span style={itemTitle}>網站管理員設定</span>
              </div>
              <Row className="g-3">
              {adminRoutesList.map(r => (
                <Col xs={6} key={r.path}>
                  <Card className="card">
                    <Link className="btn-link" to={r.path}>{r.label}
                      <NavigateNextIcon className="next-icon" />
                    </Link>
                  </Card>
                </Col>
              ))}
              </Row>
            </>
          )}
        </div>
      </Container>
    </React.Fragment>
  );
}

export function filterByRole(routes, role) {
  return routes.filter(r => {
    if (!r.roles || r.roles.length === 0) return true;
    return r.roles.includes(role);
  });
}

export function groupRoutes(routes) {
  return routes.reduce((acc, route) => {
    const group = route.group || "other";
    if (!acc[group]) acc[group] = [];
    acc[group].push(route);
    return acc;
  }, {});
}
